import {makeStyles} from "@material-ui/core";

export default function useStyles() {
    return makeStyles((theme) => ({
        root: {
            width: '100%',
            position: 'relative',
            paddingTop: 0,
            paddingBottom: 0,
        },
        linkTitle: {
          cursor: 'pointer',
          fontWeight: '500',
        },
        progress: {
            margin: 2,
            color: theme.palette.primary.main
        },
        item: {
            paddingLeft: 2,
            paddingRight: 2,
            display: 'block'
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        ul: {
            backgroundColor: 'inherit',
            padding: 0,
        },
        card: {
            minWidth: 275,
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        pos: {
            marginBottom: 12,
        },
        fab: {
            backgroundColor: '#159B78',
            '&:hover': {
                backgroundColor: 'white',
                color: '#159B78',
                border: '1px solid #159B78'
            },
            iconDelete: {
                margin: 2,
                fontSize: 32
            },
        },
        iconRemove: {
            color: '#ff7676 !important',
            cursor: 'pointer',
            '&:hover': {
                color: '#159B78 !important',
            },
        },
        iconEdit: {
            color: '#6b61ff !important',
            cursor: 'pointer',
            '&:hover': {
                color: '#159B78 !important',
            },
        },
        inline: {
            cursor: 'pointer',
            "&:hover": {
                color: theme.palette.primary.main,
              },
        },
        icons: {
            color: '#159B78 !important',
            width: '18px'
        },
        titleCartoes: {
        },
        titleContatos: {
            fontWeight: 'bold'
        },
        cardList: {
            backgroundColor: '#dfdfdf  !important',
            padding: '2%',
            width: '100%'
        },
        avatar: {
          backgroundColor: theme.palette.secondary.main,
          color:  theme.palette.text.secundary
      },
    }));
}